<template>
    <div class="sidebar">
        <el-menu
            class="sidebar-el-menu"
            :default-active="onRoutes"
            :collapse="collapse"
            background-color="#324157"
            text-color="#bfcbd9"
            active-text-color="#20a0ff"
            unique-opened
            style='width: 200px'
            router
        >
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu
                                v-if="subItem.subs"
                                :index="subItem.index"
                                :key="subItem.index"
                            >
                                <template slot="title">{{ subItem.title }}</template>
                                <el-menu-item
                                    v-for="(threeItem,i) in subItem.subs"
                                    :key="i"
                                    :index="threeItem.index"
                                >{{ threeItem.title }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item
                                v-else
                                :index="subItem.index"
                                :key="subItem.index"
                            >{{ subItem.title }}</el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
import bus from '../common/bus';
export default {
    data() {
        return {
            collapse: false,
            items: [
                // {
                //     icon: 'el-icon-lx-home',
                //     index: 'dashboard',
                //     title: '系统首页'
                // },


                {
                    icon: 'el-icon-shouye',
                    index: 'indexTable',
                    title: '首页'
                },
                {
                    icon: 'el-icon-qiye',
                    index: 'enterpriseMg',
                    title: '企业管理',
                    subs: [
                        {
                            index: 'EnterpriseTable',
                            title: '企业名单'
                        },


                        {
                            index: 'SewageTankTable',
                            title: '污水罐设置'
                        },


                    ]
                }
                ,
                {
                    icon: 'el-icon-tubiaozhizuomoban-38',
                    index: 'carMg',
                    title: '车辆管理',
                    subs: [
                        {
                            icon: 'el-icon-xiaochengxuyonghu',
                            index: 'table',
                            title: '司机管理'
                        },

                        {
                            index: 'CarManageTable',
                            title: '车辆管理'
                        }



                    ]
                }
                ,

                {
                    icon: 'el-icon-yujing',
                    index: 'alarm',
                    title: '预警中心',
                    subs: [
                        {
                            index: 'SewageTankAlarm',
                            title: '污水灌预警'
                        },

                        {
                            index: 'CarAlarm',
                            title: '车辆预警'
                        }
                        // ,
                        //
                        // {
                        //     index: 'TransportTankAlarm',
                        //     title: '运输信息'
                        // }


                    ]
                }
                ,
                {
                    icon: 'el-icon-biaoxinxiguanli',
                    index: 'infomanage',
                    title: '信息中心',
                    subs: [

                        {
                            index: 'TransportTankAlarm',
                            title: '运输信息'
                        },
                        {
                            index: 'OrderAlarm',
                            title: '订单信息'
                        },
                        {
                            icon: 'el-icon-chongzhi',
                            index: 'MoneyDetailsTable',
                            title: '费用列表'
                        }



                    ]
                }
                ,
                {
                    icon: 'el-icon-houtaiyonghuguanli',
                    index: 'UserBackground',
                    title: '用户管理'
                }
                ,
                // {
                //     icon: 'el-icon-chongzhi',
                //     index: 'MoneyDetailsTable',
                //     title: '费用列表'
                // }
                // ,

                {
                    icon: 'el-icon-_canshu_canshushezhi',
                    index: 'ParamTable',
                    title: '系统设置'
                }
            ]
        };
    },
    computed: {
        onRoutes() {
            return this.$route.path.replace('/', '');
        }
    },
    created() {
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', msg => {
            this.collapse = msg;
            bus.$emit('collapse-content', msg);
        });
    }
};
</script>

<style scoped>
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 70px;
    bottom: 0;
    overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
    width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
    width: 160px;
}
.sidebar > ul {
    height: 100%;
}
</style>
